<template>
	<div class="w-100 amelipro-callback">
		<AmeliproCard
			:card-title="cardTitle"
			classes="amelipro-callback__card"
		>
			<template #default>
				<div class="d-flex flex-column flex-sm-row align-center w-100 amelipro-callback__card__main-content">
					<div class="d-flex w-100">
						<img
							v-if="imgUrl"
							alt=""
							class="mx-4 amelipro-callback__img"
							:max-width="imgWidth"
							:min-width="imgMinWidth"
							:src="imgUrl"
							:width="imgWidth"
						>

						<AmeliproIcon
							v-else
							class="mx-4 amelipro-callback__img"
							:icon="failure ? 'croix' : 'check'"
							:icon-bg-color="failure ? 'ap-error' : 'ap-success'"
							icon-color="ap-white"
							:size="imgWidth"
						/>

						<slot name="defaultContent">
							<div
								v-if="contentTitle || contentText"
								class="d-flex flex-column ml-2 amelipro-callback__content"
							>
								<span
									:aria-level="3"
									class="mb-2 font-weight-semibold text-h6 amelipro-callback__title"
									role="heading"
									:style="style"
								>
									{{ contentTitle }}
								</span>

								<slot name="text">
									<p class="amelipro-callback__text">
										{{ contentText }}
									</p>
								</slot>
							</div>
						</slot>
					</div>

					<AmeliproBtn
						v-if="retryBtn"
						bordered
						class="mt-4 mt-sm-0 amelipro-callback__retry-btn"
						color="ap-white"
						hover-color="ap-blue lighten-3"
						:href="transmissionHref"
						rounded
						text-color="ap-blue darken-1"
						:to="transmissionTo"
						@click="emitTransmissionClickEvent"
					>
						Réessayer
					</AmeliproBtn>
				</div>

				<slot name="contentBottom" />
			</template>
		</AmeliproCard>
		<div
			v-if="$slots.cardActions"
			class="mt-4 amelipro-callback__actions"
		>
			<slot name="cardActions" />
		</div>
	</div>
</template>

<script setup lang="ts">
	import { PropType, computed } from 'vue';
	import AmeliproBtn from '../AmeliproBtn/AmeliproBtn.vue';
	import AmeliproCard from '../AmeliproCard/AmeliproCard.vue';
	import AmeliproIcon from '../AmeliproIcon/AmeliproIcon.vue';
	import { IndexedObject } from '../../types';
	import { RawLocation } from 'vue-router';
	import { convertToHex } from '../../functions/convertToHex';

	const props = defineProps({
		cardTitle: {
			type: String,
			default: undefined,
		},
		contentText: {
			type: String,
			default: undefined,
		},
		contentTitle: {
			type: String,
			default: undefined,
		},
		contentTitleColor: {
			type: String,
			default: 'ap-grey darken-1',
		},
		failure: {
			type: Boolean,
			default: false,
		},
		imgMinWidth: {
			type: String,
			default: '100',
		},
		imgUrl: {
			type: String,
			default: undefined,
		},
		imgWidth: {
			type: String,
			default: '32px',
		},
		retryBtn: {
			type: Boolean,
			default: false,
		},
		transmissionHref: {
			type: String,
			default: undefined,
		},
		transmissionTo: {
			type: [Array, Object, String] as PropType<RawLocation>,
			default: undefined,
		},
	});

	const style = computed<IndexedObject>(() => ({ color: convertToHex(props.contentTitleColor) }));

	const emit = defineEmits(['click:transmission']);

	const emitTransmissionClickEvent = (): void => {
		emit('click:transmission');
	};

</script>

<style lang="scss" scoped>
	.amelipro-callback__retry-btn {
		margin-left: 0;

		@media #{$media-up-sm} {
			margin-left: 1rem;
		}
	}
</style>
